/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlUserOrderByMethods = {
    Created: 'created'
} as const;
export type ControlUserOrderByMethods = typeof ControlUserOrderByMethods[keyof typeof ControlUserOrderByMethods];


export function ControlUserOrderByMethodsFromJSON(json: any): ControlUserOrderByMethods {
    return ControlUserOrderByMethodsFromJSONTyped(json, false);
}

export function ControlUserOrderByMethodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserOrderByMethods {
    return json as ControlUserOrderByMethods;
}

export function ControlUserOrderByMethodsToJSON(value?: ControlUserOrderByMethods | null): any {
    return value as any;
}

